var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMyEyeExamsBig = function SvgMyEyeExamsBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.667 0H3.333c-.92 0-1.666.746-1.666 1.667v36.666c0 .921.745 1.667 1.666 1.667h33.334c.92 0 1.666-.746 1.666-1.667V1.667C38.333.746 37.588 0 36.667 0zm0 38.333H3.333V1.667h33.334v36.666z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 33.333h1.666v-5h3.334v5h1.666v-6.666h-6.666v6.666zM15 31.667h-5v-3.334h5v-1.666H8.333v6.666H15v-1.666zM25 28.333h5v3.334h-5v1.666h6.667v-6.666H25v1.666zM25.833 21.667V17.5h-1.666V20H17.5v-5h4.167v-1.667H17.5v-5h6.667v2.5h1.666V6.667h-12.5v1.666h2.5V20h-2.5v1.667h12.5z",
    fill: "#333"
  })));
};
export default SvgMyEyeExamsBig;